import(/* webpackMode: "eager" */ "/Users/tho.nguyenkim2011/Git/core/websites/vnis-client/src/app/[locale]/not-found.tsx")